module.exports = __webpack_public_path__ + "static/media/hourglass.3c216249.gif";